import { TokenProvider } from '@fluidx/office-fluid-types';
import { DriverInfo } from '../DriverInfo';
import { prefetchOdcTokens, prefetchOdspTokens } from '../TokenPrefetch';

export function attemptTokenPrefetch(tokenProvider: TokenProvider, driverInfo: DriverInfo) {
  // We can start making optimistic token fetches in parallel to the iframe loading to reduce end to end latency.
  // This assumes the host's token provider is capable of reusing in flight token requests to provide better performance.
  if (tokenProvider.identityType === 'Consumer') {
    prefetchOdcTokens(tokenProvider).catch(() => {});
  } else {
    prefetchOdspTokens(tokenProvider, [driverInfo.documentUrl]).catch(() => {});
  }
}

// cspell:ignore Odsp, prefetch
